export default __webpack_public_path__ + "static/media/login.9625859c.svg";